import { MARKET_NEWS } from "@/data/marketIntelligence";
import { EconomicCalendar } from "@/components/offers/EconomicCalendar";

export const MarketIntelligence = () => (
  <section className="market-intelligence" data-testid="market-intelligence">
    <div className="market-section-heading"><h2 className="t-h5" data-testid="market-intelligence-heading">Market intelligence</h2><span data-testid="market-synthetic-label">Synthetic market brief</span></div>
    <div className="market-intelligence-layout">
      <div className="market-news" data-testid="market-news">
        <div className="market-news-heading"><h3 className="t-h6">Market news</h3><span>UTC</span></div>
        {MARKET_NEWS.map((item) => <article key={item.id} className="market-news-item" data-testid={`market-news-${item.id}`}>
          <div><span>{item.category}</span><span>{item.time}</span></div><p>{item.title}</p>
        </article>)}
      </div>
      <EconomicCalendar />
    </div>
  </section>
);